"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sansSerif = {
    0x20: [0, 0, .25],
    0x21: [.694, 0, .319],
    0x22: [.694, -0.471, .5],
    0x23: [.694, .194, .833],
    0x24: [.75, .056, .5],
    0x25: [.75, .056, .833],
    0x26: [.716, .022, .758],
    0x27: [.694, -0.471, .278],
    0x28: [.75, .25, .389],
    0x29: [.75, .25, .389],
    0x2A: [.75, -0.306, .5],
    0x2B: [.583, .082, .778],
    0x2C: [.098, .125, .278],
    0x2D: [.259, -0.186, .333],
    0x2E: [.098, 0, .278],
    0x2F: [.75, .25, .5],
    0x30: [.678, .022, .5],
    0x31: [.678, 0, .5],
    0x32: [.677, 0, .5],
    0x33: [.678, .022, .5],
    0x34: [.656, 0, .5],
    0x35: [.656, .021, .5],
    0x36: [.677, .022, .5],
    0x37: [.656, .011, .5],
    0x38: [.678, .022, .5],
    0x39: [.677, .022, .5],
    0x3A: [.444, 0, .278],
    0x3B: [.444, .125, .278],
    0x3D: [.37, -0.13, .778],
    0x3F: [.704, 0, .472],
    0x40: [.704, .011, .667],
    0x41: [.694, 0, .667],
    0x42: [.694, 0, .667],
    0x43: [.705, .011, .639],
    0x44: [.694, 0, .722],
    0x45: [.691, 0, .597],
    0x46: [.691, 0, .569],
    0x47: [.704, .011, .667],
    0x48: [.694, 0, .708],
    0x49: [.694, 0, .278],
    0x4A: [.694, .022, .472],
    0x4B: [.694, 0, .694],
    0x4C: [.694, 0, .542],
    0x4D: [.694, 0, .875],
    0x4E: [.694, 0, .708],
    0x4F: [.715, .022, .736],
    0x50: [.694, 0, .639],
    0x51: [.715, .125, .736],
    0x52: [.694, 0, .646],
    0x53: [.716, .022, .556],
    0x54: [.688, 0, .681],
    0x55: [.694, .022, .688],
    0x56: [.694, 0, .667],
    0x57: [.694, 0, .944],
    0x58: [.694, 0, .667],
    0x59: [.694, 0, .667],
    0x5A: [.694, 0, .611],
    0x5B: [.75, .25, .289],
    0x5D: [.75, .25, .289],
    0x5E: [.694, -0.527, .5],
    0x5F: [-0.038, .114, .5],
    0x61: [.46, .01, .481],
    0x62: [.694, .011, .517],
    0x63: [.46, .01, .444],
    0x64: [.694, .01, .517],
    0x65: [.461, .01, .444],
    0x66: [.705, 0, .306, { ic: .041 }],
    0x67: [.455, .206, .5],
    0x68: [.694, 0, .517],
    0x69: [.68, 0, .239],
    0x6A: [.68, .205, .267],
    0x6B: [.694, 0, .489],
    0x6C: [.694, 0, .239],
    0x6D: [.455, 0, .794],
    0x6E: [.455, 0, .517],
    0x6F: [.46, .01, .5],
    0x70: [.455, .194, .517],
    0x71: [.455, .194, .517],
    0x72: [.455, 0, .342],
    0x73: [.46, .01, .383],
    0x74: [.571, .01, .361],
    0x75: [.444, .01, .517],
    0x76: [.444, 0, .461],
    0x77: [.444, 0, .683],
    0x78: [.444, 0, .461],
    0x79: [.444, .204, .461],
    0x7A: [.444, 0, .435],
    0x7E: [.327, -0.193, .5],
    0xA0: [0, 0, .25],
    0x131: [.444, 0, .239],
    0x237: [.444, .205, .267],
    0x300: [.694, -0.527, 0],
    0x301: [.694, -0.527, 0],
    0x302: [.694, -0.527, 0],
    0x303: [.677, -0.543, 0],
    0x304: [.631, -0.552, 0],
    0x306: [.694, -0.508, 0],
    0x307: [.68, -0.576, 0],
    0x308: [.68, -0.582, 0],
    0x30A: [.694, -0.527, 0],
    0x30B: [.694, -0.527, 0],
    0x30C: [.654, -0.487, 0],
    0x391: [.694, 0, .667],
    0x392: [.694, 0, .667],
    0x393: [.691, 0, .542],
    0x394: [.694, 0, .833],
    0x395: [.691, 0, .597],
    0x396: [.694, 0, .611],
    0x397: [.694, 0, .708],
    0x398: [.716, .021, .778],
    0x399: [.694, 0, .278],
    0x39A: [.694, 0, .694],
    0x39B: [.694, 0, .611],
    0x39C: [.694, 0, .875],
    0x39D: [.694, 0, .708],
    0x39E: [.688, 0, .667],
    0x39F: [.715, .022, .736],
    0x3A0: [.691, 0, .708],
    0x3A1: [.694, 0, .639],
    0x3A2: [.716, .021, .778],
    0x3A3: [.694, 0, .722],
    0x3A4: [.688, 0, .681],
    0x3A5: [.716, 0, .778],
    0x3A6: [.694, 0, .722],
    0x3A7: [.694, 0, .667],
    0x3A8: [.694, 0, .778],
    0x3A9: [.716, 0, .722],
    0x3D2: [.716, 0, .778],
    0x3DC: [.691, 0, .569],
    0x2013: [.312, -0.236, .5],
    0x2014: [.312, -0.236, 1],
    0x2015: [.312, -0.236, 1],
    0x2017: [-0.038, .114, .5],
    0x2018: [.694, -0.471, .278],
    0x2019: [.694, -0.471, .278],
    0x201C: [.694, -0.471, .5],
    0x201D: [.694, -0.471, .5],
    0x2044: [.75, .25, .5],
    0x2206: [.694, 0, .833],
};
//# sourceMappingURL=sans-serif.js.map